import { Component, effect, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { TranslocoModule } from '@jsverse/transloco';

import { AmplifyAuthenticatorModule, AuthenticatorService } from '@aws-amplify/ui-angular';
import { LanguagesComponent } from "../../languages/languages.component";
import { LanguagesService } from '../../languages/languages-service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupJourneyStore, Link, ProductStore } from 'journey-store';
import { NavService } from '0-app-desktop/service/nav-service';
import { Hub } from 'aws-amplify/utils';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'amplify-login',
  standalone: true,
  templateUrl: './amplify-login.html',
  styleUrls: ['./amplify-login.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  imports: [
    TranslocoModule,
    AmplifyAuthenticatorModule,
    LanguagesComponent,
    CommonModule,
    MatProgressSpinner
  ],
})
export class AmplifyLoginComponent implements OnInit {
  linkData:Link = undefined;
  
  private navService = inject(NavService);
  
  private productStore = inject(ProductStore);
  private gjStore = inject(GroupJourneyStore);


  langServices = inject(LanguagesService);
  showComponent = true;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private redirectURL: string = '/';


  authLoading = false;

  constructor(
    public authenticator: AuthenticatorService,
  ) {
    this.linkData = this.route.snapshot.data['linkData'];

    effect(() => {
      const lang = this.langServices.currentLang$();
      //Dirty trick to force the amplify component to re-render
      //I'm not proud of it :(
      this.showComponent = false;
      setTimeout(() => this.showComponent = true, 100);
    });
  }
  ngOnInit(): void {
    this.resetUserData();

    this.authenticator.subscribe((authState) => {
      //Show spinner when configuring (e.g., coming back from google sso)
      if (authState.authStatus === 'configuring') {
        this.authLoading = true;
      }

      if (authState.authStatus === 'unauthenticated') {
        this.authLoading = false;
      }

      if (authState.authStatus === 'authenticated') {
        this.navService.navigateAfterLogin();
      }
    });
  }

  //Clear user and data
  private resetUserData() {
    this.productStore.reset();
    this.gjStore.clearJourneys();
  }
}
